import { css } from 'lit';
import { differenceInDays, format, formatDistanceToNow, formatRelative } from 'date-fns';

function formatRelativeDate(date: number) {
	const daysDiff = differenceInDays(new Date(), date);

	if (daysDiff < 6) {
		return formatRelative(date, new Date());
	}
	if (daysDiff <= 30) {
		return formatDistanceToNow(date, { addSuffix: true });
	}
	return format(date, 'PPp');
}

export default formatRelativeDate;
